import script from "./MapVip.vue?vue&type=script&setup=true&lang=js"
export * from "./MapVip.vue?vue&type=script&setup=true&lang=js"

import "./MapVip.vue?vue&type=style&index=0&id=3ec2033e&lang=less"

const __exports__ = script;

export default __exports__